import styled from 'styled-components';

export const StyledFarmDeliveries = styled('div')`
  .ant-drawer-footer {
    display: flex;
    gap: 10px;
  }

  .ant-table-thead {
    .ant-table-cell {
      font-weight: 400;
      color: ${(props) => props.theme.black};
    }
  }

  .ant-table-cell.centered-column {
    text-align: center;
  }
`;
